<template>
  <h5 class="pap-form__form-header card-header bg-primary text-white">
    <div class="icon-wrapper"><i :class="iconclass"></i></div>
    <div>{{ title }}</div>
  </h5>
</template>

<script>
export default {
  name: 'FormTitle',
  props: ['title', 'iconclass'],
};
</script>

<style >
</style>